export default "__VITE_ASSET__bb5bf3fe__"